import { render, staticRenderFns } from "./CustomerAddressInput.vue?vue&type=template&id=6f0aad22&scoped=true"
import script from "./CustomerAddressInput.vue?vue&type=script&lang=js"
export * from "./CustomerAddressInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0aad22",
  null
  
)

export default component.exports